import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
    title: {
        fontWeight: "700",
        fontSize: "20px",
        lineHeight: "45px",
        color: ({ theme }) => theme.palette.text.primary,
        justifyContent: 'flex-start',
        display: 'flex',
    },
    sectionsWrapper: {
        backgroundColor: ({ theme }) => theme.palette.bgColor,
        boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2)",
        borderRadius: "10px",
        paddingInline: "10px 5px",
        fontFamily: "Rubik",
        paddingBottom: "1rem",
        display: "flex",
        justifyContent: "space-between",
        marginRight: "10px",
        marginLeft: "10px",
        flexDirection: "column",
        marginBottom: "20px",
    },
    wrapper: {
        justifyContent: 'flex-start',
        display: 'flex',
        width: '100%',
        marginLeft: ({ isNavbarOpen }) => isNavbarOpen ? "21%" : "12%",
    },
    tableWrapper: {
        width: '100%',
    },
    actionsContainer: {
        display: "flex",
        gap: "10px",
        height: '100%',
        alignItems: 'center',
        width: '60%'
    },
    actionBtn: {
        backgroundColor: ({ theme }) => theme.palette.button.primary,
        fontSize: "11px",
        color: ({ theme }) => theme.palette.text.primary,
        border: "2px solid #A8ABC2",
        fontWeight: 700,
        fontFamily: "Rubik",
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
});
